<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="A3g"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Dedication">
<p><br/> <br/></p>
<p class="center" id="pz3-1"><em>For Adam, my son<br/> and in many ways my teacher.</em> <br/> <br/></p>
<p>Son, how can I help you see?</p>
<p id="pz5-3">May I give you my shoulders to stand on?</p>
<p id="pz5-4">Now you see farther than me.</p>
<p id="pz5-5">Now you see for both of us.</p>
<p id="pz5-6">Won’t you tell me what you see?</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?41de82c6